import { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminContext } from '../../Contextos/AdminContext';
const AdminGate = ({ children }) => {
  const { logged, checking, ensureSession } = useContext(AdminContext);
  useEffect(() => { ensureSession(); }, [ensureSession]);
  if (checking) return <main className="sib-admin"><p role="status">Comprobando acceso...</p></main>;
  return logged ? children : <Navigate to="/login" replace />;
};
export default AdminGate;
